require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/dimmer.css');
require('./section6.styl');

import React from 'react';

import Lightbox from 'react-image-lightbox';

import Image4 from './imgs/4.jpg';
import Image5 from './imgs/5.jpg';

class Section6 extends React.Component {

    constructor(props) {
        super(props);

        this.state = ({
          isOpen1: false,
          isOpen2: false
        })

    }

    render() {

        return (

            <div className='section four wrapper'>

                <div className={`ui  dimmable ${this.props.readerMadeHisChoice ? '' : 'dimmed'} segment padded`}>
                    <div className='ui inverted simple dimmer'></div>

                        {/*<h3>Neun Operationen, neun Vollnarkosen</h3>*/}

<p className='section-text'>
  Die Berechnung der relativen Armut, basierend auf Steuerdaten, weist jedoch einige Schwächen auf und wird deshalb immer wieder kritisiert. <strong>Sie überschätzt die Zahl der betroffenen Haushalte</strong> und Personen, weil sie Konkubinate nicht erfasst. Zudem sind darin Studenten und Menschen mit einbezogen, die sich bewusst für einen Lebensstil mit wenig Einkommen entschieden haben. Armut ist aber nur dann ein Problem, wenn Menschen keine andere Wahl haben. Gleichzeitig unterschätzt die relative Messung die Zahl der Betroffenen, weil quellenbesteuerte Ausländer ohne Niederlassungsbewilligung nicht berücksichtigt werden. In der Regel werden jene mit einem Einkommen unter 120'000 Franken quellenbesteuert.                        </p>

<p className='section-text'>
  Daher hält es die Armutsforschung für ungenügend, einzig das Portemonnaie als Richtwert zu nehmen. Man ist sich einig, dass Armut <a href='http://www.statistik.zh.ch/internet/justiz_inneres/statistik/de/aktuell/mitteilungen/2010/armutsrechner.html' target='_blank'>vielschichtiger ist und auch immaterielle Faktoren beinhaltet.</a> Faktoren wie die Wohnsituation, Freizeit, Gesundheit, soziale Kontakte, Bildung und Zufriedenheit.
                        </p>

                  { this.state.isOpen1 &&
                  <Lightbox
                    mainSrc={Image4}
                    imageCaption='Trotz Zen: Der finanzielle Abstieg war für Oliver eine «harte Prüfung».'
                    onCloseRequest={() => this.setState({isOpen1: false})}
                  />
                  }


                  <div className='section text image wrapper'>

                    <img
                      src={Image4} width='100%'
                      onClick={() => this.setState({ isOpen1: true })}
                    />

                    <p className='bild legend'>Trotz Zen: Der finanzielle Abstieg war für Oliver eine «harte Prüfung».</p>
                  </div>


                  <p className='section-text'>
                    «Yoga und Zen-Meditation haben mir im Umgang mit meiner Krankheit extrem geholfen», sagt Oliver, «auch als ich vor gut einem Jahr ganz unten ankam.» Er habe verinnerlicht, mit wenig auszukommen und daraus das Beste zu schöpfen. Es wäre aber gelogen, dass er es einfach so weggesteckt hätte. Es sei eine «harte Prüfung» seiner Lebensphilosophie gewesen. <strong>Er schämte sich.</strong>                         </p>

<p className='section-text'>
  Immer wieder spricht Oliver davon, dass er sich gut vorstellen könne, dass ein solcher Abstieg Depressionen oder Suizidgedanken auslöse: «Ich hatte die nicht», beteuert er. Doch wer kein Geld habe in dieser Stadt und für andere Menschen sorgen sollte, der komme an seine Grenzen. «Das Schlimmste ist, wenn Menschen unter deiner Armut leiden, die noch weniger dafür können als du selbst – wie zum Beispiel mein Sohn.» Und das tun viele: Rund ein Drittel der Sozialhilfebezüger <a href='http://skos.ch/uploads/media/FAQ_2013_01.pdf' target='_blank'>sind Kinder</a>.
                        </p>

<p className='section-text'>
  Oliver wurde dünnhäutiger. Zum Beispiel als seine Ex, mit der er eigentlich ein gutes Verhältnis pflegt, mit ihrem Sohn nach Italien verreiste. Sie habe ihm das erst kurzfristig vor den Ferien mitgeteilt, sagt er. Sie entgegnete, sie habe es ihm schon vor längerer Zeit erzählt. Egal wer recht hat, in jenem Moment machte es ihn wütend. <strong>Plötzlich habe er «strukturelle Gewalt» gespürt:</strong> «Die Bank erhöht einfach so die Schreibgebühren um ein paar Franken, obwohl sie durch die Digitalisierung weniger Aufwand hat.» Oder als die EC-Karte über Wochen hinweg nicht funktionierte: Die Bank suchte den Schuldigen beim Herausgeber der Karte, der Kartenherausgeber beim Apparat. «Mir wurde wochenlang der legitime Zugriff auf mein Geld verwehrt», sagt Oliver. Da sei er in der Schalterhalle etwas laut geworden. «Der Sicherheitsdienst hat mich rausbegleitet.» Auf einmal verstehe man, weshalb Menschen auf einem Amt ausrasten.
                        </p>

                  <p className='section-text'>
                    Nach langer Wartezeit hat Oliver eine volle IV-Rente zugesprochen bekommen. Er gehört somit zu <a href='https://www.stadt-zuerich.ch/sd/de/index/beratung/sozialhilfe/faq.html' target='_blank'>den 60 Prozent</a>, die jeweils nach rund einem Jahr die Sozialhilfe wieder verlassen können. Er öffnet auf seinem Notebook eine Tabelle: «Budget: Stand 23.10.2016» «Seit einigen Wochen bin ich nun raus aus der Sozialhilfe», sagt er. Oliver lächelt wie ein Kind, das erschöpft von einem langen Tag noch ein Bettmümpfeli erhält. Die Ausgaben in der Tabelle sind in drei Kategorien unterteilt: in den Grundbedarf 2622 Franken (Miete, Essen, Krankenkasse), in jene Ausgaben, die «allen zugutekommen» 505.75 Franken (Yoga, Ausgaben für den Sohn, Internet) und in Luxus 477.20 Franken (Beitrag für die Schweizerische Narkolepsie Gesellschaft, Kultur, Geschenke).
                  </p>

                  { this.state.isOpen2 &&
                  <Lightbox
                    mainSrc={Image5}
                    imageCaption='Oliver ist zuversichtlich: «Ich schaffe das.»'
                    onCloseRequest={() => this.setState({isOpen2: false})}
                  />
                  }


                  <div className='section text image wrapper'>

                    <img
                      src={Image5} width='100%'
                      onClick={() => this.setState({ isOpen2: true })}
                    />

                    <p className='bild legend'>Oliver ist zuversichtlich: «Ich schaffe das.»</p>
                  </div>

<p className='section-text'>
  Oliver wird nun monatlich rund 3600 Franken bekommen. IV-Rente, Ergänzungsleistungen, Kinder- und Pensionskassen-Rente. Unvorhergesehene Ausgaben können Oliver aber immer noch aus der Bahn werfen. Er lebt rein rechnerisch weiterhin an der Armutsgrenze. «Ich schaffe das. Damit komme ich durch», sagt er. Wenn er eine Frau kennen lerne, sage er aber weiterhin: <strong>«Ich bin arm. Ich bin krank und …»</strong>, es fällt ihm wieder ein, «… ich will keine weiteren Kinder mehr.» Nun bricht Oliver das Gespräch ab. Er muss sich hinlegen – die Narkolepsie.
</p>
<p className='section-text'>
  Einige Tage später schreibt Oliver ein Mail. Es sei ihm wichtig, etwas Abschliessendes zu sagen: «Ich sehe mich als einer von vielen, die so oft nicht gesehen werden, nicht einmal von jenen, die ihnen am nächsten stehen.» Das sei ein Grund mehr, weshalb er seine Geschichte nur anonymisiert wiedergeben möchte. Als Stellvertreter. Als einer von Tausenden.

</p>

                </div>

            </div>
        );
    }
}

Section6.defaultProps = {};

Section6.propTypes = {
    readerIsCityCitizen: React.PropTypes.bool,
    readerMadeHisChoice: React.PropTypes.bool
};

export default Section6;



// WEBPACK FOOTER //
// ./src/components/section6/section6.js